import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
// Service
import { ObjectUtils } from '@cv-invision/core';
import { ViewsService } from '../../../services/views.service';
// Model
import {
	CvLayoutRenderExtraDataModel,
	LayoutComponentBroadcast,
	LayoutRenderLayoutItem,
	LayoutRenderSchemaData
} from '../models/cv-layout-render.model';
import { ORDER_STATE } from '../../../rule-engine/rules/models';

@Injectable()
export class LayoutRenderService {
	extraData = new CvLayoutRenderExtraDataModel();
	components: any = {};
	layout: any = {};

	get isEditable(): boolean {
		return this.extraData.isEditing;
	}

	get activateEditableUX(): boolean {
		return this.isEditable &&
			(
				// this.viewService.order.status !== ORDER_STATE.REJECTED &&
				// this.viewService.order.status !== ORDER_STATE.APPROVED &&
				this.viewService.order.status !== ORDER_STATE.CANCELLED
			);
	}

	// Internal Component Broadcast Connection
	public componentBroadcast: Subject<LayoutComponentBroadcast> = new Subject<LayoutComponentBroadcast>();

	constructor(protected viewService: ViewsService) {
		//
	}

	/**
	 * Re-initialization of internal component broadcast
	 */
	setSubjects(): void {
		this.componentBroadcast = new Subject<LayoutComponentBroadcast>();
	}

	/**
	 * set the extraData param
	 *
	 * @param data
	 */
	setExtraData(data: any): void {
		this.extraData = data;
	}

	/**
	 * Get the extradata param, if exists.
	 * @param option
	 * @returns Any || null
	 */
	getExtraDataOption(option: string): any {
		if (option in this.extraData) {
			return this.extraData[option];
		}

		return null;
	}

	/**
	 * Entry point, given the schema Version, set the services variables
	 * that will hold the components & layout for the complete module.
	 *
	 * @param data LayoutRenderSchemaData
	 */
	setSchema(schemaData: LayoutRenderSchemaData): void {
		this.components = schemaData.components;
		this.layout = this.mapComponents(ObjectUtils.recursiveDeepCopy(schemaData.layout));
	}

	/**
	 * RECURSIVE FUNCTION
	 * Map the layout and add the component class in it.
	 *
	 * @param layout
	 */
	mapComponents(layout: any): any {
		if (!layout) {
			return layout;
		}

		if ('[object Array]' === Object.prototype.toString.apply(layout)) {
			for (let index = 0; index < layout.length; index += 1) {
				layout[index] = this.mapComponents(layout[index]);
			}
		}

		if (!Array.isArray(layout) && typeof layout === 'object') {
			for (const key in layout) {
				if (layout[key] && typeof layout[key] === 'object') {
					layout[key] = this.mapComponents(layout[key]);
				}

				if (key === 'type') {
					layout['widget'] = this.components[layout.type];
					layout['permissionToRender'] = this.hasPermissionAccess(layout);
				}
			}
		}

		return layout;
	}

	/**
	 * Validate the user has access to the component if it is behind a Permission Set
	 * @param item
	 */
	private hasPermissionAccess(item: LayoutRenderLayoutItem): boolean {
		// at the layoutLevel? add permission service here
		let hasPermissionAccess = true;
		if (item && item.widget.hasPermissionAccess) {
			hasPermissionAccess = item.widget.hasPermissionAccess() !== null;
		}

		return hasPermissionAccess;
	}
}
